import { Phone, Mail } from "lucide-react";
import { T, PHONE_HREF, EMAIL_HREF } from "../i18n";
import { Reveal } from "./Reveal";

export const CtaBand = ({ lang }) => {
  const t = T[lang];
  return (
    <section className="relative overflow-hidden py-20" data-testid="cta-band">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(245,124,0,0.15),transparent_60%)]" />
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">{t.ctaBandTitle}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-slate-400">{t.ctaBandSub}</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a href={PHONE_HREF} className="flex items-center gap-2 rounded-full bg-amber-500 px-8 py-4 text-base font-bold text-obsidian transition-all hover:bg-amber-300 hover:shadow-[0_0_32px_rgba(245,124,0,0.5)]" data-testid="cta-call-button">
              <Phone size={18} /> {t.stickyCall}
            </a>
            <a href={EMAIL_HREF} className="flex items-center gap-2 rounded-full border border-amber-500/50 px-8 py-4 text-base font-semibold text-amber-300 transition-colors hover:bg-amber-500/10" data-testid="cta-email-button">
              <Mail size={18} /> {t.stickyEmail}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
